import PropTypes from 'prop-types'
import React from 'react'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

const VisibilityOff = ({ className }) => <VisibilityOffIcon className={className} />

export default VisibilityOff

VisibilityOff.propTypes = {
  className: PropTypes.string
}
